import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../../services/utils/config.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AddimageService} from '../../services/data/addimage.service';

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements AfterViewInit {
    @ViewChild('signatureCanvas') signatureCanvasRef: ElementRef;
    private signatureUrl = `${environment.API}${environment.RESOURCES.SIGNATURES}`;
    private ctx: CanvasRenderingContext2D;
    private isDrawing = false;
    @Input() signatureElementId: string;
    @Input() enableSaveButton = false;

    constructor(private readonly http: HttpClient, private readonly configService: ConfigService, private readonly addImageService: AddimageService) {
        this.signatureUrl = `${configService.getBaseApiUrl}${environment.RESOURCES.SIGNATURES}`;
    }

    ngAfterViewInit() {
        this.initializeCanvas();
        this.addImageService.setCanvasMapEntry(this.signatureElementId, false);
    }

    initializeCanvas() {
        const canvas = this.signatureCanvasRef.nativeElement;
        this.ctx = canvas.getContext('2d');

        if (!this.ctx) {
            throw new Error('No canvas context found');
        }

        this.ctx.strokeStyle = 'black';
        this.ctx.lineWidth = 2;
        this.ctx.lineCap = 'round';
        this.ctx.lineJoin = 'round';

        this.ctx.clearRect(0, 0, canvas.width, canvas.height);

        canvas.addEventListener('mousedown', this.startDrawing.bind(this));
        canvas.addEventListener('mousemove', this.draw.bind(this));
        canvas.addEventListener('mouseup', this.stopDrawing.bind(this));
        canvas.addEventListener('mouseout', this.stopDrawing.bind(this));

        canvas.addEventListener('touchstart', this.startDrawing.bind(this));
        canvas.addEventListener('touchmove', this.draw.bind(this));
        canvas.addEventListener('touchend', this.stopDrawing.bind(this));
        canvas.addEventListener('touchcancel', this.stopDrawing.bind(this));
    }

    startDrawing(event: MouseEvent | TouchEvent) {
        event.preventDefault();
        this.isDrawing = true;
        const pos = this.getCursorPosition(event);
        this.ctx.beginPath();
        this.ctx.moveTo(pos.x, pos.y);
        this.addImageService.setCanvasMapEntry(this.signatureElementId, true);
    }

    draw(event: MouseEvent | TouchEvent) {
        event.preventDefault();
        if (!this.isDrawing) {
            return;
        }
        const pos = this.getCursorPosition(event);
        this.ctx.lineTo(pos.x, pos.y);
        this.ctx.stroke();
    }

    stopDrawing(event: MouseEvent | TouchEvent) {
        event.preventDefault();
        this.isDrawing = false;
        this.ctx.closePath();
    }

    getCursorPosition(event: MouseEvent | TouchEvent) {
        const canvas = this.signatureCanvasRef.nativeElement;
        const rect = canvas.getBoundingClientRect();
        let x, y;

        if (event instanceof MouseEvent) {
            x = event.clientX - rect.left;
            y = event.clientY - rect.top;
        } else if (event instanceof TouchEvent) {
            const touch = event.touches[0];
            x = touch.clientX - rect.left;
            y = touch.clientY - rect.top;
        }

        return {x, y};
    }

    saveSignature() {
        const canvas = this.signatureCanvasRef.nativeElement;

        this.ctx.globalCompositeOperation = 'destination-over';

        const dataURL = canvas.toDataURL('image/png');
        return this.addImageService.getCanvasTouched(this.signatureElementId) ? this.uploadSignature(dataURL) : Observable.of(false);
    }

    clearSignature() {
        const canvas = this.signatureCanvasRef.nativeElement;
        this.ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.addImageService.setCanvasMapEntry(this.signatureElementId, false);
    }

    uploadSignature(signature: string): Observable<any> {
        const formData = new FormData();
        formData.append('image', signature);

        return this.http.post(this.signatureUrl, formData);
    }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/signature/signature.component.ts